export function formatPrice(value: number | null | undefined, currency = 'EUR'): string {
  if (value == null) return '-';
  const hasDecimals = value % 1 !== 0;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(value) + ' ' + currency;
}
